export default "__VITE_ASSET__B8Buwmyw__"